import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { setCookies, setPermissions } from '../hooks/useCookies';
import { SERVER_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const login = 'login';
export const logIn = createAsyncThunk('api/logIn', async (data) => {
  const body = { email: data.email, password: data.Password };
  return axios
    .post(`${SERVER_URL}/${login}`, body, { headers })
    .then((response) => {
      if (response.status === 200) {
        // Check if OTP is required
        if (response.data.data.requiresOtp) {
          // Don't set cookies yet, just return the response
          return response.data;
        }

        // Normal login flow
        setCookies('Token', response.data.data.tokens.access.token);
        setCookies('refreshToken', response.data.data.tokens.refresh.token);
        setCookies('USERID', response.data.data.user.id);
        setCookies('PROFILE', response.data.data.user.image);
        setCookies('USERNAME', response.data.data.user.name);
        setCookies('USERROLE', response.data.data.user.role.name);
        setPermissions(response.data.data.user.role.permissions);
        setCookies('ISSUPERADMIN', response.data.data.user.role.isSuperAdmin || false);
        setCookies('THEME', 'false');
        return response.data;
      }
      return response;
    })
    .catch((e) => e);
});

// Send OTP
export const sendOtp = createAsyncThunk('api/sendOtp', async (userId) => {
  const body = { userId };
  return axios
    .post(`${SERVER_URL}/send-otp`, body, { headers })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error;
    });
});

// Verify OTP
export const verifyOtp = createAsyncThunk('api/verifyOtp', async ({ userId, otp, trustDevice }) => {
  const body = { userId, otp, trustDevice };
  return axios
    .post(`${SERVER_URL}/verify-otp`, body, { headers })
    .then((response) => {
      if (response.status === 200) {
        // Set cookies after successful OTP verification
        setCookies('Token', response.data.data.tokens.access.token);
        setCookies('refreshToken', response.data.data.tokens.refresh.token);
        setCookies('USERID', response.data.data.user.id);
        setCookies('PROFILE', response.data.data.user.image);
        setCookies('USERNAME', response.data.data.user.name);
        setCookies('USERROLE', response.data.data.user.role.name);
        setPermissions(response.data.data.user.role.permissions);
        setCookies('ISSUPERADMIN', response.data.data.user.role.isSuperAdmin || false);
        setCookies('THEME', 'false');
        return response.data;
      }
      return response;
    })
    .catch((error) => {
      throw error.response?.data || error;
    });
});

// Resend OTP
export const resendOtp = createAsyncThunk('api/resendOtp', async (userId) => {
  const body = { userId };
  return axios
    .post(`${SERVER_URL}/resend-otp`, body, { headers })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error;
    });
});

const loginSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    loginData: {},
    error: '',
    otpLoading: false,
    otpError: '',
  },
  extraReducers: {
    [logIn.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
      state.error = '';
    },
    [logIn.fulfilled]: (state, action) => {
      state.loading = false;
      state.loginData = action.payload;
    },
    [logIn.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Send OTP
    [sendOtp.pending]: (state) => {
      state.otpLoading = true;
      state.otpError = '';
    },
    [sendOtp.fulfilled]: (state) => {
      state.otpLoading = false;
    },
    [sendOtp.rejected]: (state, action) => {
      state.otpLoading = false;
      state.otpError = action.error.message;
    },
    // Verify OTP
    [verifyOtp.pending]: (state) => {
      state.otpLoading = true;
      state.otpError = '';
    },
    [verifyOtp.fulfilled]: (state, action) => {
      state.otpLoading = false;
      state.loginData = action.payload;
    },
    [verifyOtp.rejected]: (state, action) => {
      state.otpLoading = false;
      state.otpError = action.error.message;
    },
    // Resend OTP
    [resendOtp.pending]: (state) => {
      state.otpLoading = true;
      state.otpError = '';
    },
    [resendOtp.fulfilled]: (state) => {
      state.otpLoading = false;
    },
    [resendOtp.rejected]: (state, action) => {
      state.otpLoading = false;
      state.otpError = action.error.message;
    },
  },
});

export default loginSlice.reducer;
